import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { MatConfirmDialogComponent } from '../dialogs/mat-confirm-dialog/mat-confirm-dialog.component';

@Injectable({ providedIn: 'root' })
export class DialogService {

    constructor(private dialog: MatDialog) {}



    openConfirmDialog(message: string, name: string, endMessage = '') {
        return this.dialog.open(MatConfirmDialogComponent, {
            data: {
                endMessage,
                message,
                name
            },
            disableClose: true,
            panelClass: 'confirm-dialog-container',
            backdropClass: 'dark-blurred-background',
            position: { top: '100px' },
            width: '470px'
        });
    }



    openSaveChangesDialog(itemName: string) {
        return this.dialog.open(MatConfirmDialogComponent, {
            data: {
                endMessage: '',
                message: `Do you want to save changes ${itemName}? If not, data will be lost.`,
                name: itemName
            },
            disableClose: true,
            panelClass: 'confirm-dialog-container',
            backdropClass: 'dark-blurred-background',
            position: { top: '100px' },
            width: '470px'
        });
    }



}
